import { TabType } from '../types';
import { SwitcherProps } from './types';

import Accounts from './Tabs/Accounts/Accounts';
import DataPermissions from './Tabs/DataPermissions/DataPermissions';
import General from './Tabs/General/General';
import Permissions from './Tabs/Permissions/Permissions';

const TabRenderer = ({ currentTab, ...props }: SwitcherProps) => {
  switch (currentTab) {
    case TabType.GENERAL:
      return <General {...props} />;
    case TabType.LOGICAL_PERMISSIONS:
      return <Permissions {...props} />;
    case TabType.DATA_PERMISSIONS:
      return <DataPermissions {...props} />;
    case TabType.USERS:
      return <Accounts {...props} />;
    default:
      return <div />;
  }
};

export default TabRenderer;
